<template>
<form @submit.prevent="submit" autocomplete="off">
    <ui-alert type="error" v-for="e,index in errors" :key="index" :dismissible="false">{{ e }}</ui-alert>

    <ui-textbox label="Adres e-mail" name="email" type="text" v-model="item.email" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz adres e-mail"></ui-textbox>

    <i-select-multiple name="groups" label="Grupy" :keys="keysForSelect" v-model="item.groups_ids" :options="groups" search-placeholder="Szukaj" :show-search="true" placeholder="Wybierz grupy"
        required></i-select-multiple>

    <div class="form-actions">
        <ui-button color="primary">{{ item.id ? 'Aktualizuj' : 'Dodaj' }}</ui-button>
    </div>
</form>

</template>
<script>
import Loading from '../../mixins/Loading'
import Notify from '../../mixins/Notify'
import FormErrors from '../../mixins/FormErrors'
import Utils from '../../services/Utils'

import Emails from './../../services/Emails'
import EmailGroups from './../../services/EmailGroups'

export default {
  mixins: [Loading, Notify, FormErrors],
  props: ['item'],
  data () {
    return {
      groups: [],
      errors: [],
      statuses: Emails.statuses(),
      keysForSelect: Utils.keysForSelect(),
      errorMessages: Utils.errorMessages(['required', 'min', 'numeric', 'email'])
    }
  },
  mounted () {
    this.getGroups()
  },
  methods: {
    getGroups () {
      this.setLoading(true)
      EmailGroups.names().then((res) => {
        this.groups = res.data.items
        this.setLoading(false)
      })
    },
    error (err) {
      this.errors = this.getResponseErrors(err)
      this.notify('Wystąpiły błędy')
    },
    success (res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.notify('Zmieniłeś adres e-mail')
          this.$router.push({
            name: 'admin.emails.show',
            params: {
              id: this.item.id
            }
          })
        }
      } else {
        if (res.status === 201) {
          this.notify('Dodałeś adres e-mail')
          this.$router.push({
            name: 'admin.emails.show',
            params: {
              id: res.data.item.id
            }
          })
        }
      }
    },
    submit () {
      this.errors = []
      window.scrollTo(0, 0)

      let item = {}
      if (this.item.id) {
        item.id = this.item.id
      }
      item.email = this.item.email
      item.groups_ids = this.item.groups_ids

      if (this.item.id) {
        Emails.update(item).then(this.success, this.error)
      } else {
        Emails.create(item).then(this.success, this.error)
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// Form.vue?62907a81